/**
 * Created by mqamhieh on 12/28/16.
 */
import {
    INTERVIEW_SET_TYPES,
} from '../../interview-v2/constants/interview.constant.js';

window.AMSManageLaneTemplatesForm = function (scope, formData, Upload) {
    var form = this;
    var formName = "ams-manage-lane-templates-form";
    var _protected = BaseForm.call(form, formName, scope);
    var _emitter = JarEventEmitter.call(form);

    form.laneId;
    form.templates = [];
    form.interviewTemplateAttachments = [];

    var defaultInterviewTemplate = {
        name: "New Template",
        message: $filter("translate")("Hello")
                + " {candidate_first_name},\n\n"
                + $filter("translate")("Congratulations") + "!"
                + " {brand_name} "
                + $filter("translate")("would like to invite you to an interview for the")
                + " {job_position} "
                + $filter("translate")("position")
                + ". "
                + $filter("translate")("Schedule a time and date for your interview by clicking below")
                + "."
                +  $filter("translate")(" Your interview will be held at ")
                + "{interview_location}."
                + "\n\n{interview_link}\n"
    };

    var originalTemplate;
    var activeIndex;
    form.activeTemplate;
    form.type = formData.type;
    form.interviewTemplate = formData.interviewTemplate;
    form.interviewType = formData.interviewType;
    form.TEMPLATE_TYPES = INTERVIEW_SET_TYPES;
    form.isPhoneInterview = formData.interviewType === form.TEMPLATE_TYPES.PHONE;

    if (form.interviewType === 'PHONE') {
        defaultInterviewTemplate.message = $filter("translate")("Hello")
            + " {candidate_first_name},\n\n"
            + $filter("translate")("Congratulations") + "!"
            + " {brand_name} "
            + $filter("translate")("would like to invite you to a phone interview for the")
            + " {job_position} "
            + $filter("translate")("position")
            + ". "
            + $filter("translate")("Schedule a time and date for your interview by clicking below")
            + "."
            + "\n\n{interview_link}\n";
    }

    let getSmartFields = async () => {
        const params = {
            template_category: form.interviewCategory,
        };
        if (form.isPhoneInterview) {
            params.template_type = form.TEMPLATE_TYPES.PHONE;
        }
        const allSmartFields = await InterviewV2API.getMessageTemplateSmartFields(params);
        if (form.interviewCategory === 'VIDEO_INTERVIEW') {
            form.smartFields = allSmartFields.filter(field => field.code !== 'interview_location' && field.code !== 'interviewers_names');
        } else {
            form.smartFields = allSmartFields.filter(field => field.code !== 'video_interview_link' && field.code !== 'interviewers_names');
        }
    }

    let setDefaultMessage = () => {
        if (form.interviewCategory === 'VIDEO_INTERVIEW') {
            defaultInterviewTemplate.message = `${$filter("translate")("Hello")} {candidate_first_name},\n\n${$filter("translate")("Congratulations")}! {brand_name} ${$filter("translate")("would like to invite you to a video interview for the")} {job_position} ${$filter("translate")("position")}. ${$filter("translate")("Schedule a time and date for your video interview by clicking below")}. ${$filter("translate")("At the time of your video interview click here to join")} {video_interview_link}.\n\n{interview_link}`;
        } else {
            defaultInterviewTemplate.message = `${$filter("translate")("Hello")} {candidate_first_name},\n\n${$filter("translate")("Congratulations")}! {brand_name} ${$filter("translate")("would like to invite you to an interview for the")} {job_position} ${$filter("translate")("position")}. ${$filter("translate")("Schedule a time and date for your interview by clicking below")}. ${$filter("translate")("Your interview will be held at")} {interview_location}.\n\n{interview_link}`;
        }
    }

    form.load = function (laneId) {
        var defer = $q.defer();
        form.laneId = laneId;
        form.interviewCategory = formData.interviewCategory;
        form.positionCode = formData.positionCode;
        getSmartFields();
        setDefaultMessage();
        form.loadingActive = true;
        form.brandId = formData.brandId;

        var promise;

        if (!form.interviewTemplate) {
            promise = CustomLanesAPI.getTemplates(laneId, formData.brandId, formData.jobId, { include_parent: true, load: 'FIRST' });
        } else {
            promise = InterviewV2API.getBrandMessageTemplates(formData.brandId, form.interviewType, form.interviewCategory, form.positionCode);
        }

        promise.then(function (templates) {

            if (!form.interviewTemplate) {
                form.templates = (formData.jobId)? templates.job_templates: templates.brand_templates;
                form.viewOnlyTemplates = templates.enterprise_templates;
            } else {
                form.templates = templates.message_templates.map(function (template) {
                    return {
                        name: template.title,
                        message: template.message,
                        id: template.id,
                        ownerBrandId: template.owner_brand_id,
                        mode: template.mode,
                        type: template.type,
                        attachments: template.attachments || []
                    }
                });
            }

            if (!form.templates.length) {
                form.addTemplate();
            }
            else {
                form.selectTemplate(0);
            }

            delete form.loadingActive;
            defer.resolve();
        }, function () {

            form.addTemplate();
            delete form.loadingActive;
            defer.resolve();
        });

        return defer.promise;
    };

    form.setNewTemplateData = function (newTemplateData) {

        form.confirmDiscard()
            .then(function (hadChanges) {
                if (hadChanges) {
                    form.discardChanges(true);
                }

                if (!form.activeTemplate.id) {
                    form.activeTemplate = newTemplateData
                }
                else {
                    form.addTemplate(newTemplateData);
                }

                scope.$digest();
            });
    };

    form.addTemplate = function (templateData) {
        form.interviewTemplateAttachments = [];
        form.confirmDiscard()
            .then(function (hadChanges) {
                // Only here if there is no changes, or a discard was confirmed

                if (hadChanges) {
                    // Remove changes if we have any (discarded)
                    form.discardChanges(true);
                }

                var index = activeIndex;
                // Init name, message and attachments (mainly for change detection purposes)
                var emptyTemplate = { name: '', message: '', attachments: [] };

                if (templateData) {
                    emptyTemplate = $.extend(emptyTemplate, templateData);
                }

                if (form.activeTemplate && !form.activeTemplate.id) {
                    // Replace the current template if it has no id (not save before)
                    if (!form.interviewTemplate) {
                        form.templates[activeIndex] = emptyTemplate;
                    } else {
                        form.templates[activeIndex] = angular.copy(defaultInterviewTemplate);
                    }
                }
                // Add a new one, if the current template has id (already saved before)
                else if (!form.interviewTemplate) {
                    index = (form.templates.push(emptyTemplate)) - 1;
                }
                else {
                    index = (form.templates.push(angular.copy(defaultInterviewTemplate))) - 1;
                }

                // Select the new template
                doTemplateSelect(index);
                scope.$digest();
            });
    };

    form.saveTemplate = function () {
        form.validator.validate(function (isValid) {
            if (isValid) {

                if (!form.interviewTemplate) {

                    var URL = CustomLanesAPI.getCreateTemplateURL(form.laneId, formData.brandId, formData.jobId);
                    var method = "POST";
                    var requestData = $.extend({}, form.activeTemplate);

                    if (form.activeTemplate.id) {
                        URL += "/" + form.activeTemplate.id;
                        method = "PUT";
                    }

                    form.loadingActive = true;
                    form.savingActive = true;
                    form.uploadProgress = 0;

                    if (requestData.new_attachments && requestData.new_attachments.length) {
                        form.showProgress = true;
                    }

                    requestData.attachments = _.pluck(requestData.attachments, "id");

                    Upload.upload({
                        'url': URL,
                        'method': method,
                        'withCredentials': true,
                        'headers': {},
                        'data': requestData,
                        'Content-Type': 'multipart/form-data',
                        'arrayKey': '[]'
                    }).progress(function (evt) {
                        form.uploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (data, status, headers, config) {
                        delete form.loadingActive;
                        delete form.savingActive;
                        delete form.showProgress;

                        // file is uploaded successfully
                        if (data.status_code == 200) {
                            if (data.data.template) {
                                form.templates[activeIndex] = data.data.template;
                                form.activeTemplate = form.templates[activeIndex];
                                doTemplateSelect(activeIndex);
                            }
                        }
                        else {
                            console.error("Error while saving template:", data);
                        }
                    }).error(function (reason) {
                        delete form.loadingActive;
                        delete form.savingActive;
                        delete form.showProgress;
                        console.error("Error while saving template:", reason);
                    });
                }

                else {

                    var saveOrUpdateTemplateRequest = InterviewV2API.addBrandMessageTemplate;

                    var template = {
                        title: form.activeTemplate.name,
                        message: form.activeTemplate.message,
                        type: form.activeTemplate.type || form.interviewType,
                        category: form.interviewCategory,
                        attachments: form.interviewTemplateAttachments.map((att) => {
                            return {
                                file_path: att.file_path,
                                file_name: att.file_name,
                                mime_type: att.mime_type
                            };
                        })
                    };

                    if (form.activeTemplate.id) {
                        template.id = form.activeTemplate.id;
                        saveOrUpdateTemplateRequest = InterviewV2API.updateBrandMessageTemplate;
                    }

                    form.savingActive = true;

                    saveOrUpdateTemplateRequest(formData.brandId, template).then(function (data) {
                        delete form.savingActive;

                        if(!template.id) {
                            template.id = data.id;
                        }

                        form.templates[activeIndex] = {
                            name: template.title,
                            message: template.message,
                            id: template.id,
                            attachments: form.interviewTemplateAttachments
                        };

                        form.activeTemplate = form.templates[activeIndex];
                        doTemplateSelect(activeIndex);

                        scope.$digest();

                    }, function (reason) {
                        delete form.savingActive;
                        console.error("Error while saving template:", reason);
                        scope.$digest();
                    });
                }

            }
        });
    };

    var doTemplateSelect = function (index, viewMode) {
        var templateToSelect = (viewMode === 'VIEW_ONLY' && !form.interviewTemplate)? form.viewOnlyTemplates[index]: form.templates[index];
        originalTemplate = $.extend({}, templateToSelect, true);
        originalTemplate.attachments = $.extend([], templateToSelect.attachments);
        form.interviewTemplateAttachments = templateToSelect.attachments || []

        if (activeIndex != index && form.activeTemplate && !form.activeTemplate.id) {
            removeTemplateFromView(activeIndex);
        }

        activeIndex = index;
        form.activeTemplate = templateToSelect;

        if (!form.interviewTemplate) {

            if (form.activeTemplate.id && !form.activeTemplate.message) {
                form.loadingActive = true;

                CustomLanesAPI.getTemplateDetails(form.activeTemplate.id, form.laneId, formData.brandId, formData.jobId)
                    .then(function (template) {

                        if (viewMode === 'VIEW_ONLY') {
                            form.viewOnlyTemplates[index] = template;
                            form.activeTemplate = form.viewOnlyTemplates[index];
                            form.activeTemplate.viewOnly = true;
                        }
                        else {
                            form.templates[index] = template;
                            form.activeTemplate = form.templates[index];
                        }

                        originalTemplate = $.extend({}, form.activeTemplate, true);
                        originalTemplate.attachments = $.extend([], form.activeTemplate.attachments);

                        setTimeout(function () {
                            form.validator.validate();
                        }, 100);

                        delete form.loadingActive;
                        scope.$digest();
                    }, function (error) {
                        console.error(error);
                        delete form.loadingActive;
                        scope.$digest();
                    });
            }
            else if (form.activeTemplate.id) {
                setTimeout(function () {
                    form.validator.validate();
                }, 100);
            }

            if (viewMode === 'VIEW_ONLY') {
                form.activeTemplate.viewOnly = true;
            }
            else {
                setTimeout(function () {
                    $("input[name='templateName']").focus();
                }, 100);
            }
        }
    };

    form.selectTemplate = function (index, mode) {
        form.confirmDiscard()
            .then(function (hadChanges) {
                if (hadChanges) {
                    form.discardChanges(true);
                }

                doTemplateSelect(index, mode);
                scope.$digest();
            });
    };

    form.addAttachments = function (files) {
        if (files && files.length) {
            form.activeTemplate.new_attachments = form.activeTemplate.new_attachments || [];
            form.activeTemplate.new_attachments = form.activeTemplate.new_attachments.concat(files);
        }
    };

    form.removeAttachment = function (type, index) {
        form.activeTemplate[type].splice(index, 1);
    };

    form.deleteTemplate = function (index) {
        index = isNaN(index)? activeIndex: index;
        var templateToDelete = form.templates[index];

        if (templateToDelete.id) {
            hConfirm(
                $filter("translate")("Are you sure you want to delete this template?"),
                function (confirmed) {
                    if (confirmed) {
                        form.loadingActive = true;

                        var promise;

                        if (!form.interviewTemplate) {
                            promise = CustomLanesAPI.deleteTemplate(templateToDelete.id, form.laneId, formData.brandId, formData.jobId)
                        } else {
                            promise = InterviewV2API.deleteBrandMessageTemplate(formData.brandId, templateToDelete.id);
                        }

                        promise.then(function (res) {
                            removeTemplateFromView(index);
                            delete form.loadingActive;
                            scope.$digest();
                        }, function (err) {
                            console.error(err);
                            delete form.loadingActive;
                            scope.$digest();
                        });

                        scope.$digest();
                    }
                }
            );
        }
        else {
            removeTemplateFromView(index);
        }
    };

    form.hasChanges = function () {

        if (originalTemplate && form.activeTemplate) {

            if (form.activeTemplate.viewOnly) {
                return false;
            }


            if (originalTemplate.name != form.activeTemplate.name) {
                return true;
            }

            if (originalTemplate.message != form.activeTemplate.message) {
                return true;
            }

            if (!form.interviewTemplate) {
                if (originalTemplate.attachments.length !== form.activeTemplate.attachments.length) {
                    return true;
                }

                if (form.activeTemplate.new_attachments && form.activeTemplate.new_attachments.length) {
                    return true;
                }
            }
        }

        return false;
    };

    var removeTemplateFromView = function (index) {
        form.templates.splice(index, 1);
        activeIndex = null;
        form.activeTemplate = null;
        
        if (form.templates.length) {
            doTemplateSelect(0);
        }
        else {
            form.addTemplate();
        }
    };

    form.confirmDiscard = function () {
        var defer = $q.defer();

        if (form.hasChanges()) {
            hConfirm($filter("translate")("Are you sure you want to discard changes to this template?"),
                function (confirmed) {
                    if (confirmed) {
                        // True for confirmed discard
                        defer.resolve(true);
                    }
                    else {
                        defer.reject();
                    }
                });
        }
        else {
            // False for has no changes to discard
            defer.resolve(false);
        }


        return defer.promise;
    };

    form.discardChanges = function (dontSelect) {
        form.templates[activeIndex] = originalTemplate;

        if (!dontSelect) {
            form.selectTemplate(activeIndex);
        }
    };
    
    form.discardOrHide = function () {
        if (form.hasChanges()) {
            form.discardChanges();
        }
        else {
            _emitter.trigger('done');
        }
    };

    form.validator.validateCustom = function (field, optionsField, rule, showError) {
        const value = form.validator.getFieldValue(field);
        switch (rule.name) {
            case "required-fields":
                form.messingRequiredFields = [];
                for (let i in form.smartFields) {
                    let field = form.smartFields[i];
                    if (field.necessity === "REQUIRED" && value.indexOf(field.code) === -1) {
                        form.messingRequiredFields.push(field);
                    }
                }
                if (form.messingRequiredFields.length) {
                    return false;
                }
                break;
        }

        return true;
    };

    form.uploadInterviewTemplateAttachment = async ($files) => {
        if (!$files?.length) return;
        const file = $files[0];

        const allowedTypes = [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg'
        ];

        if (!allowedTypes.includes(file.type)) {
            Utils.hAlert({
                title: $filter("translate")("Upload error"),
                text: $filter("translate")("Only PDF, Word, and image files are allowed.")
            });
            return;
        }

        if (Utils.getFileSizeMB(file) > 10) {
            Utils.hAlert({
                title: $filter("translate")("Upload error"),
                text: $filter("translate")("File size exceeds 10MB limit.")
            });
            return;
        }

        try {
            form.uploadingAttachment = true;
            const fileName = file.name.split('.').slice(0, -1).join('_').replace(/\s+/g, '_');
            const fileExtension = file.name.split('.').pop();

            const presignedUrlResponse = await InterviewV2API.getAttachmentPresignedUrl({
                type: InterviewV2API.attachmentsPresignedTypes.INTERVIEW_INVITE_TEMPLATE,
                brandId: form.brandId,
                fileExtension: fileExtension,
                fileName:fileName,
            });
            const {href, s3_path} = presignedUrlResponse;

            Upload.http({
                url: href,
                method: 'PUT',
                headers: {'Content-Type': ''},
                'Content-Type': '',
                data: file,
            }).success(async () => {
                form.interviewTemplateAttachments.push({
                    file_path: s3_path,
                    file_name: file.name,
                    mime_type: file.type,
                    file_href: await form.getFileHref(presignedUrlResponse.s3_path),
                });
                form.uploadingAttachment = false;
            }).error(() => {
                HNotifications.show({
                    title: $filter("translate")("Upload error"),
                    desc: $filter("translate")("Could not upload file"),
                    type: "danger"
                });
            });
        } catch (error) {
            console.error('Error fetching presigned URL:', error);
        }
    };

    form.getFileHref = async (s3Path) => {
        const response = await InterviewV2API.getAttachmentPresignedUrl({
            type: InterviewV2API.attachmentsPresignedTypes.INTERVIEW_INVITE_TEMPLATE,
            brandId: form.brandId,
            s3Path: s3Path,
        });
        return response.href;
    }

    form.removeInterviewTemplateAttachment = (index) => {
        form.interviewTemplateAttachments.splice(index, 1);
    };
};